enum AssignmentTypes {
  Contractor = 'Contractor',
  SubContractor = 'SubContractor',
}
export default AssignmentTypes;
